import { Tooltip } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../../common/mixin';
export class InternalTooltipComponent extends ChameleonElementMixin(Tooltip) {
}
